/*
    Видео с ютуба/вимео на странице
*/

class YoutubeVideo {
    constructor(el) {
        this.container = el;
        this.inner = this.container.querySelector('.js-video-inner');
        this.src = this.container.getAttribute('data-url');
        this.active = false;

        this.bindClick();
    }



    bindClick() {
        if (!this.src) {
            return;
        }

        this.inner.addEventListener('click', () => {
            this.active = this.container.classList.contains('_is-active');

            // Если видео уже было запущено, ничего не делаем
            if (this.active) {
                return;
            }

            // Добавляем айфрейм с видео
            if (!this.container.classList.contains('js-plyr-wrapper')) {
                this.inner.insertAdjacentHTML('beforeend',
                    '<iframe src="' + this.getIframeSrc() + this.getVideoId() + '?rel=0&title=0&byline=0&portrait=0&autoplay=1" width="100%" height="100%" frameborder="0" allowfullscreen></iframe>'
                );
            } else {
                if (!this.container.hasAttribute('data-video-upload')) {
                    const iframeSrc = this.getIframeSrc().indexOf('youtube') >= 0 ? 'youtube' : 'vimeo';

                    this.inner.insertAdjacentHTML('afterbegin',
                        '<div class="js-plyr" data-plyr-provider="' + iframeSrc + '" data-plyr-embed-id="' + this.getVideoId() + '"></div>'
                    );
                } else {
                    this.inner.insertAdjacentHTML('afterbegin',
                        `<video class="js-plyr">
                            <source src="${this.src}" type="video/mp4" />
                        </video>`
                    );
                }

                new Plyr(this.container.querySelector('.js-plyr'), {
                    autoplay: true,
                    controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'settings', 'pip', 'airplay', 'fullscreen'],
                });
            }

            this.container.classList.add('_is-active');
        });
    }


    /**
     * Получаем id видео из ссылок ютуба и вимео
     */
    getVideoId() {
        const parts = this.src.split('/');
        const id = parts[parts.length - 1];

        return id;
    }


    /**
     * Получаем атрибут src для айфрейма
     */
    getIframeSrc() {
        if (this.src.indexOf('youtube.com/') !== -1 || this.src.indexOf('youtu.be/') !== -1) {
            // Если это Youtube
            return 'https://www.youtube.com/embed/';
        } else {
            // Если Vimeo
            return 'https://player.vimeo.com/video/';
        }
    }
}


document.querySelectorAll('.js-video').forEach(el => {
    new YoutubeVideo(el);
});



// WEBPACK FOOTER //
// ./_src/js/YoutubeVideo.js